import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { requestStepup, subscribeDeclined, type StepupApp } from '../auth/stepupStore'
import styles from './StepUpBanner.module.css'

const BRAND: Record<StepupApp, string> = { pazuru: 'Naforo', tsumi: 'Yiriba' }

/** Shown after the user dismissed the verification sheet: the pages behind it only show a generic
 *  load error, so this says why and re-opens the sheet. `onVerified` refreshes the failed queries. */
export function StepUpBanner({ onVerified }: { onVerified: () => void }) {
  const { t } = useTranslation()
  const [app, setApp] = useState<StepupApp | null>(null)
  useEffect(() => subscribeDeclined(setApp), [])
  if (!app) return null
  return (
    <div className={styles.banner} role="status">
      <span>{t('mobile.stepup.declined.body', { app: BRAND[app] })}</span>
      <button type="button" className={styles.action}
        onClick={() => { void requestStepup(app).then((ok) => { if (ok) onVerified() }) }}>
        {t('mobile.stepup.declined.action')}
      </button>
    </div>
  )
}
